<template>
  <div>
    <div
      v-if="errors"
      class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
      </p>
    </div>

    <!-- comments declarations -->
    <div v-if="comment_declarations.length != 0">
      <div class="flex flex-col pb-4">
        <div class="flex flex-col shadow-md bg-gray-100 mb-1 pt-0 p-3">
          <div class="p-2">
            <div class="flex justify-between">
              <h2
                class="text-red text-lg text-bold capitalize mt-2 pb-4 pt-2 border-red-light ml-0"
              >{{ $t("requests.remarques")}}</h2>
              <div class="flex items-center w-auto bg-white pb-4 mr-0 mt-3">
                <sp-button
                  theme="outline-blue"
                  space="small"
                  type="submit"
                  class="justify-end rounded add-comment-btn"
                  @click="showModal()"
                >
                  <i class="fas fa-comment-dots"></i>
                  {{ $t("form.write_comment")}}
                </sp-button>
              </div>
            </div>

            <div v-for="(comment_dec,index) in comment_declarations" :key="index">
              <ul class="comments-timeline">
                <li>
                  <time class="comment-time">
                    <span>{{new Date(comment_dec.created_at)| dateFormat('DD/MM/YYYY HH:mm')}}</span>
                  </time>
                  <div class="comment-icon">
                    <div v-if="comment_dec.user_id === candidat.id">
                      <i class="icon-message icon-message-candidat fas fa-comment-dots"></i>
                      <!-- <img class="img-message" src="../../assets/img/icon_candidat.svg" alt="icon message candidat" /> -->
                    </div>
                    <div v-else>
                      <i class="icon-message icon-message-responsible fas fa-comment-dots"></i>
                      <!-- <img class="img-message"  src="../../assets/img/icon_admin.svg" alt="icon message admin"/> -->
                    </div>
                  </div>

                  <div class="flex-wrap comment-content">
                    <div class="flex">
                      <h4 v-if="comment_dec.user_id === candidat.id">{{comment_dec.last_name}} {{comment_dec.name }} &nbsp;</h4>
                      <h4 v-else>{{ $t("team.team_startupact")}} &nbsp;</h4>
                      <p>{{ $t("form.added_comment")}} &nbsp;</p>
                    </div>

                    <blockquote>
                      <p class="blockquote blockquote-primary" v-html="comment_dec.content"></p>
                    </blockquote>
                    <div v-if="comment_dec.document_id">
                      <a :href="comment_dec.path" download target="_blank">{{ $t("requests.download_file") }}</a>
                    </div>
                    <div v-else>
                      <div v-if="comment_dec.document_path">
                      <a :href="comment_dec.document_path" download target="_blank">{{ $t("requests.download_file") }}</a>
                    </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="comment_declarations.length == 0"
      class="flex items-center justify-end w-auto bg-white mx-0"
    >
      <sp-button
        theme="outline-blue"
        space="small"
        type="submit"
        class="justify-end rounded add-comment-btn"
        @click="showModal()"
      >
        <i class="fas fa-comment-dots"></i>
        {{ $t("form.write_comment")}}
      </sp-button>
    </div>

    <!-- Modal add comment declaration -->
    <commentDeclaration @add-comment="onClickCommentRequest" />

    <form autocomplete="off" name="formrequest" v-on:submit.prevent="declarationFormUpdate()">
      <h2 class="text-red text-lg text-bold mb-5 pb-2 py-6 border-red-light border-b">
        <span
          v-if="decRequests.type ==  7"
        >{{$t('declarations.update_declaration_financial_statement')}}</span>
        <span
          v-else-if="decRequests.type == 8"
        >{{$t('declarations.update_declaration_shareholding')}}</span>
        <span v-else-if="decRequests.type == 9">{{$t('declarations.update_declaration_activity')}}</span>

        <span v-else-if="decRequests.type == 10">{{$t('declarations.update_declaration_nb_employees')}}</span>
        <span v-else-if="decRequests.type == 16">{{$t('declarations.update_save_reporting')}}</span>
        
        <span v-else>{{$t('declarations.update_ecosystem_declaration')}}</span>
      </h2>
      <div v-if="declarationForm && declarationForm.length > 0">
        <div v-for="cat in declarationForm" :key="cat.sort_order">
          <div v-for="(q, index) in responses_questions" :key="index">
            <div v-if="cat && q.category_id">
              <div v-if="q.category_id === cat.id">
                <div v-if="startupNames && (codeName == 'DECLARATION_DE_REALISATION' || codeName == 'DECLARATION_DE_REALISATION levée de fonds') && (q.response_type == 31 || q.response_type == 10)">
                  <q-form
                    :question="{
                      ...q,
                      options: startupNames,
                      option: startupNames
                    }"
                    :responses="responses"
                    :started="true"
                    :requestFormEdit="true"
                    @update-disabled="updateDisabled"
                    :showError="showError"
                    :formType="formData.code_name"
                    @data-emitted="handleDataFromChild"
                   :data-to-pass="dataFromChild"
                  ></q-form>
                </div>
                <div v-else-if="codeName == 'INVESTOR_GUARANTEE_FORM'">
                  <q-form
                    :question="q"
                    :responses="responses"
                    :formType="codeName"
                    @response-updated="handleResponseUpdate"
                    @response-updated-labelRef="handleResponseUpdate2"
                    @label-data="handleLabelData"
                    :child-identifiant="dataIdentif"
                    :child-legal-name="dataLegalName"
                    :started="true"
                    :showError="showError"
                  ></q-form>
                </div>
                <div v-else>
                  <q-form
                    :question="q"
                    :started="true"
                    @update-disabled="updateDisabled"
                    :showError="showError"
                    :requestFormEdit="true"
                    :responses="responses"
                  ></q-form>
                </div>

              </div>
            </div>
            <div v-else>
              <q-form
                :question="q"
                :started="true"
                @update-disabled="updateDisabled"
                :showError="showError"
                :requestFormEdit="true"
                :responses="responses"
              ></q-form>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="(q, index) in responses_questions" :key="index">
          <div v-if="startupNames && (codeName == 'DECLARATION_DE_REALISATION' || codeName == 'DECLARATION_DE_REALISATION levée de fonds') && (q.response_type == 31 || q.response_type == 10)">
            <q-form
              :question="{
                ...q,
                options: startupNames,
                option: startupNames
              }"
              :responses="responses"
              :started="true"
              :requestFormEdit="true"
              :formType="codeName"
              @update-disabled="updateDisabled"
              :showError="showError"
              @data-emitted="handleDataFromChild"
              :data-to-pass="dataFromChild"
            ></q-form>
          </div>
          <div v-else-if="codeName == 'INVESTOR_GUARANTEE_FORM'">
            <q-form
              :question="q"
              :responses="responses"
              :formType="codeName"
              @response-updated="handleResponseUpdate"
              @response-updated-labelRef="handleResponseUpdate2"
              @label-data="handleLabelData"
              :child-identifiant="dataIdentif"
              :child-legal-name="dataLegalName"
              :started="true"
              :showError="showError"
            ></q-form>
          </div>
          <div v-else>
            <q-form
              :question="q"
              :started="true"
              @update-disabled="updateDisabled"
              :showError="showError"
              :requestFormEdit="true"
              :responses="responses"
            ></q-form>
          </div>
        </div>
      </div>

      <div
        v-if="decRequests.status != 2"
        class="flex items-center justify-end w-auto bg-white mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
      >
        <sp-button theme="outline-blue" space="small" type="submit">{{ $t("form.send")}}</sp-button>
      </div>
    </form>
  </div>
</template>



<script>
import ApiService from "@/common/api.service";
import { DECLARATION_FORM_UPDATE } from "@/store/actions.type";
import { mapGetters, mapState } from "vuex";
import ButtonVue from "../../components/spKit/Button.vue";
import QForm from "@/components/Candidat/QForm.vue";
import {
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp
} from "@/store/mutations.type";
import commentDeclaration from "../Label/commentDeclaration.vue";
export default {
  name: "fromrequest",
  components: {
    "sp-button": ButtonVue,
    "q-form": QForm,
    commentDeclaration: commentDeclaration
  },

  data() {
    return {
      questions: null,
      content: null,
      inProgress: false,
      isSubmitted: false,
      showError: false,
      responses: [],
      responses_questions: [],
      comment_requests: [],
      decRequests: [],
      delegation: null,
      declarationForm: [],
      comment_declarations: [],
      startupNames: [],
      codeName: null,
      dataFromChild: '',
      dataIdentif: '',
      dataLegalName: '',
      labelData: ''
    };
  },
  mounted() {
    this.$store.commit(SET_LabelMenuActive, 1);
    this.$store.commit(SET_ApplicationMenuActive, 0);
    this.$store.commit(SET_HashId, this.session.startup_application.id);
    this.$store.commit(SET_LabelApp, this.$route.params.code_label);
    this.id = this.$route.params.id;
    this.code_label = this.$route.params.code_label;
    this.appType = this.$route.params.appType;
    this.formName = this.$route.params.formName;
    this.declarationId = this.$route.params.declarationId;
    this.showDeclarationByDetail(
      this.appType,
      this.formName,
      this.declarationId
    );
  },
  created() {
    this.id = this.$route.params.id;
    this.code_label = this.$route.params.code_label;
    this.appType = this.$route.params.appType;
    this.formName = this.$route.params.formName;
    this.declarationId = this.$route.params.declarationId;
    this.showDeclarationByDetail(
      this.appType,
      this.formName,
      this.declarationId
    );
  },
  methods: {
    handleResponseUpdate(response) {
      this.dataIdentif = response;
    },
    handleResponseUpdate2(response) {
      this.dataLegalName = response;
    },
    handleLabelData(response) {
      this.labelData = response;
    },
    handleDataFromChild(data) {
      this.dataFromChild = data;
    },
    onClickCommentRequest(comment) {
      var comment_candidat = {
        content: comment[0],
        created_at: new Date(),
        last_name: this.session.user_auth.last_name,
        name: this.session.user_auth.name,
        ref_id: this.$route.params.id,
        user_id: this.session.user_auth.id,
        document_path: comment[1]
      };
      this.comment_declarations.unshift(comment_candidat);
    },
    updateDisabled(val) {
      this.inProgress = val;
      this.isSubmitted = val;
    },
    declarationFormUpdate() {
      this.$Progress.start();
      let form = this.getForm();
      this.isSubmitted = false;
      this.$store
        .dispatch(DECLARATION_FORM_UPDATE, form)
        .then(data => {
          this.isSubmitted = true;
          this.showError = true;
          this.$router.push({
              name: "Declarations",
              params: {
                app_id: this.hashId
              }
            });
         /* if (form.code_label) {
            
          } else {
            this.$router.push({
              name: "Label",
              params: {
                app_id: this.hashId
              }
            });
          }*/
        })
        .catch(err => {
          this.responses_questions = this.requestForm.questions;
          this.inProgress = false;
        });
      window.scrollTo(0, 0);
      this.$Progress.finish();
    },
    getForm() {
      this.inProgress = true;
      let finalResponses = [];
      Array.prototype.forEach.call(this.responses, final => {
        if (final.content != "") {
          finalResponses.push(final);
        }
      });
      let form = {
        code_label: this.$route.params.code_label,
        appType: this.$route.params.appType,
        formName: this.$route.params.formName,
        id: this.$route.params.id,
        declarationId: this.$route.params.declarationId,
        responses: finalResponses
      };
      return form;
    },
    // Show detail declaration form
    showDeclarationByDetail(appType, formName, declarationId) {
      this.appType = this.$route.params.appType;
      this.formName = this.$route.params.formName;
      this.declarationId = this.$route.params.declarationId;
      let qs =`${appType}/${formName}/${declarationId}`;
      ApiService.get(
        `/api/request/show-detail-declaration/${qs}`
      )
        .then(data => {
          if (Object.keys(data.data.data).length === 0) {
            this.$router.push({
              name: "Declarations",
              params: {
                app_id: this.hashId
              }
            });
          } else {
            this.responses_questions = data.data.data.form.questions;
            this.declarationForm = data.data.data.form.categories;
            this.decRequests = data.data.data.DecRequest;
            this.comment_declarations = data.data.data.comments;
            this.candidat = data.data.data.user;
            this.startupNames = data.data.data.form.startupNames;
            this.codeName = data.data.data.form.code_name;
          }
        })
        .catch(response => {
          this.$router.push({ name: "home" });
        });
    },
    showModal() {
      this.$modal.show("comment-declaration");
    }
  },

  computed: {
    ...mapGetters([
      "session",
      "requestForm",
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication"
    ]),
    ...mapState({
      errors: state => state.session.errors
    })
  }
};
</script>


<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 40%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.card.container {
  padding: 2px 16px;
}

.bg-doc {
  background-repeat: no-repeat;
  background-size: 50px 49px;
  height: 50px;
  width: 50px;
}
.border {
  border-color: #cad2e2;
}
.chip {
  padding: 0 15px;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  border-radius: 25px;
}

@import "../../assets/css/style_comments.scss";
</style>
